import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

var Value =
/** @class */
function (_super) {
  tslib_1.__extends(Value, _super);

  function Value() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isHovered: false,
      isActive: false
    };

    _this.handleMouseEnter = function () {
      _this.setState({
        isHovered: true
      });
    };

    _this.handleMouseLeave = function () {
      _this.setState({
        isHovered: false,
        isActive: false
      });
    };

    _this.handleMouseDown = function (event) {
      var _a = _this.props,
          onClick = _a.onClick,
          disabled = _a.disabled,
          value = _a.value; // As it reacts on mouseDown instead of click,
      // we need to check if the primary mouse button was pressed

      if (event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.setState({
        isActive: true
      });

      if (!disabled && onClick) {
        event.stopPropagation();
        onClick(value, event);
        return;
      }

      if (value.href) {
        event.stopPropagation();
      }
    };

    _this.handleMouseUp = function () {
      _this.setState({
        isActive: false
      });
    };

    _this.onRemove = function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onRemove(_this.props.value);
    };

    _this.handleTouchEndRemove = function (event) {
      _this.setState({
        isActive: false
      }); // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)


      if (_this.dragging) {
        return;
      }

      _this.onRemove(event);
    };

    _this.handleTouchMove = function () {
      // Set a flag that the view is being dragged
      _this.dragging = true;
    };

    _this.handleTouchStart = function () {
      _this.setState({
        isActive: true
      }); // Set a flag that the view is not being dragged


      _this.dragging = false;
    };

    _this.renderLabel = function () {
      var _a = _this.props,
          blockName = _a.blockName,
          id = _a.id,
          onClick = _a.onClick,
          children = _a.children,
          _b = _a.value,
          href = _b.href,
          target = _b.target;
      var className = blockName + "-label";

      if (onClick || href) {
        return React.createElement("a", {
          className: className,
          href: href,
          target: target,
          onMouseDown: _this.handleMouseDown,
          onMouseUp: _this.handleMouseUp,
          onTouchEnd: _this.handleMouseDown
        }, children);
      }

      return React.createElement("span", {
        className: className,
        role: "option",
        "aria-selected": "true",
        id: id
      }, children);
    };

    _this.renderIcon = function () {
      var _a = _this.props,
          blockName = _a.blockName,
          value = _a.value;
      var className = blockName + "-icon";
      return React.createElement("span", {
        className: className
      }, value.icon);
    };

    _this.renderRemoveBtn = function () {
      var _a;

      var blockName = _this.props.blockName;
      var className = cx(blockName + "-remove", (_a = {}, _a[blockName + "-remove--active"] = _this.state.isActive, _a));
      return React.createElement("span", {
        className: className,
        onMouseDown: _this.onRemove,
        onTouchEnd: _this.handleTouchEndRemove,
        onTouchStart: _this.handleTouchStart,
        onTouchMove: _this.handleTouchMove,
        "aria-hidden": true
      }, React.createElement("i", {
        className: "icon-custom-exit"
      }));
    };

    return _this;
  }

  Value.prototype.render = function () {
    var _a;

    var _b = this.props,
        blockName = _b.blockName,
        disabled = _b.disabled,
        onRemove = _b.onRemove,
        _c = _b.value,
        className = _c.className,
        icon = _c.icon,
        title = _c.title,
        style = _c.style;
    var finalClassName = cx(blockName, (_a = {}, _a[blockName + "--disabled"] = disabled, _a[blockName + "--hover"] = !disabled && this.state.isHovered, _a[blockName + "--active"] = !disabled && this.state.isActive, _a['has-icon'] = icon, _a), className);
    return React.createElement("div", {
      className: finalClassName,
      style: style,
      title: title,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave
    }, icon && this.renderIcon(), this.renderLabel(), !disabled && onRemove && this.renderRemoveBtn());
  };

  Value.propTypes = {
    blockName: PropTypes.string,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    onClick: PropTypes.func,
    onRemove: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
  };
  Value.defaultProps = {
    blockName: 'Select-value'
  };
  return Value;
}(Component);

export default Value;

try {
  // @ts-ignore
  Value.__docgenInfo = {
    "description": "",
    "displayName": "Value",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}